export enum ActionTypes {
  AddExpertInsightsRequest = 'addExpertInsights.request',
  AddExpertInsightsSuccess = 'addExpertInsights.success',
  AddExpertInsightsFailure = 'addExpertInsights.failure',
}
